import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openAnalyticsSubmenu } from '../sidebarHelpers';

const exploreRevenueTab = (baseUrl, navigate, user) => {
  return {
    id: 'exploreRevenueTab',
    title: 'Explore Revenue Tab',
    steps: [
      {
        selector: `[data-tour="analyticsLink"]`,
        content: <p>Click on the "Analytics" section in the navigation.</p>,
      },
      {
        selector: `[data-tour="dashboardLink"]`,
        content: <p>Click on the "Dashboard" in the navigation.</p>,
        actionBefore: () => openAnalyticsSubmenu('[data-tour="dashboardLink"]'),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/analytics?mainTab=revenue`, true);
        },
        selector: '[data-tour="revenueTab"]',
        content: (
          <>
            <p>The revenue tab will give you insight into the revenue from each channel and source.</p>
            <p>
              This will allow you to compare the revenue you get from each source so you can evaluate the efficiency of
              your communication and what marketing channels work better for your customers.
            </p>
            <p>
              If you have started using Releva recently the stats might show zero. Releva starts observing your website
              as soon as it is connected.
            </p>
            <p>After you turn on the product blocks and email automation you will be able to compare actual results.</p>
          </>
        ),
        stepInteraction: true,
      },
      {
        selector: '[data-tour="relevaVsOtherChart"]',
        content: (
          <>
            <p>In this section, you can see what Releva does for you.</p>
            <p>This is the recap of the revenue from each channel you can use in Releva.</p>
            <p>You can also compare each value to the previous period.</p>
          </>
        ),
      },
      {
        selector: '[data-tour="metricsSelector"]',
        content: (
          <p>
            By default we show the stats for the last 14 days, however, you can change the period according to how much
            data you want to see.
          </p>
        ),
      },
      {
        selector: '[data-tour="relevaVsOtherChart"]',
        content: (
          <>
            <p>
              In this section, we show you the sources that bring the most revenue and a comparison to the values and
              sources in the previous period.
            </p>
            <p>The graph shows you the dynamic for the current period.</p>
          </>
        ),
      },
      {
        selector: '[data-tour="storeRevenueMedium"]',
        content: (
          <p>
            Here you can have multiple mediums under one source, for example under Releva source you have mediums like
            email, recommender, Viber, etc.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exploreRevenueTab'),
  };
};

export default exploreRevenueTab;
